import { Grid } from '@mui/joy';
import { useTranslation } from 'react-i18next';

import { StatCard } from 'core/elements';
import { NumberHelper } from 'core/helpers';
import { IQuotesDashboardSummary, IQuotesDashboardSummaryItem } from 'reports/types';

interface IProps {
  isLoading: boolean;
  data?: IQuotesDashboardSummary;
}

export const StatCards = ({ isLoading, data }: IProps) => {
  const { t } = useTranslation();

  const stats = [
    { ...formatValue(data?.customerQuotes), label: t('labelCustomerQuotes') },
    { ...formatValue(data?.vendorQuotes), label: t('labelVendorQuotes') },
    { ...formatValue(data?.customerOrders), label: t('labelCustomerOrders') },
    { ...formatValue(data?.vendorOrders), label: t('labelVendorOrders') },
  ];

  return (
    <Grid container spacing={2}>
      {stats.map((stat) => (
        <Grid key={stat.label} lg={3} md={6} xs={12}>
          <StatCard
            isLoading={isLoading}
            label={stat.label}
            value={stat.count}
            secondaryValue={stat.totalPrice}
          />
        </Grid>
      ))}
    </Grid>
  );
};

const formatValue = (item?: IQuotesDashboardSummaryItem) => {
  const count = item?.count ?? 0;
  const totalPrice = NumberHelper.format({
    amount: item?.totalPrice ?? 0,
  });

  return { count, totalPrice: `$${totalPrice}` };
};
